import { render, staticRenderFns } from "./RemovedModal.vue?vue&type=template&id=4e0b6d8d&"
import script from "./RemovedModal.vue?vue&type=script&lang=js&"
export * from "./RemovedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports